import { render, staticRenderFns } from "./RecipeStep.vue?vue&type=template&id=21f74eb4&scoped=true"
import script from "./RecipeStep.vue?vue&type=script&lang=js"
export * from "./RecipeStep.vue?vue&type=script&lang=js"
import style0 from "./RecipeStep.vue?vue&type=style&index=0&id=21f74eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f74eb4",
  null
  
)

export default component.exports